import { FunctionComponent } from 'react';
import { IInstitution, ITrial, SourceDataVerificationPatient } from '@/api/dtos';
import { ListItemButton, ListItemText, Chip, Box, LinearProgress, styled } from '@mui/material'
import { Link } from 'react-router-dom';


const LabelContainer = styled('div')({
    display: 'flex'
});

const TreatmentArmChip = styled(Chip)({
    marginLeft: 'auto'
});

interface IPatientListItem {
    trial?: ITrial;
    patient?: SourceDataVerificationPatient;
    institution?: IInstitution;
}

const PatientListItem: FunctionComponent<IPatientListItem> = ({
    patient,
    institution,
    trial
}) => {
    return (
        <ListItemButton component={Link} to={`/${trial?.code}/participants/${patient?.studyNumber}`}>
            <ListItemText
                primary={
                    <LabelContainer>
                        {patient?.studyNumber}
                        {
                            patient?.treatmentArm && (
                                <TreatmentArmChip 
                                    label={patient.treatmentArm} 
                                    sx={{ml: 'auto'}} 
                                    size="small"
                                    color="primary"
                                />
                            )
                        }
                    </LabelContainer>
                }
                secondary={institution?.name}
            />
        </ListItemButton>
    );
}

export default PatientListItem;